import PropTypes from "prop-types";
import styles from "./radio-buttons.module.less";

const RadioButtons = (props) => {
  const onChange = (event) => {
    if (typeof props.onChange === "function") {
      props.onChange(event.target.name, event.target.value);
    }
  };

  return (
    <div className={[styles.radioWrapper, props.wrapperClassName].join(" ")}>
      {props.label && <label className={props.topLabelClassName}>{props.label}</label>}
      {props.options instanceof Array &&
        props.options.length > 0 &&
        props.options.map((item, index) => {
          const selected = item.value === props.value;
          return (
            <div key={index} className={[styles.itemWrapper, props.itemWrapperClassName].join(" ")}>
              <input
                className={[styles.input, "input"].join(" ")}
                type="radio"
                name={props.name}
                value={item.value}
                id={props.name + "-" + index}
                onChange={(event) => onChange(event)}
                checked={item.value === props.value}
                disabled={item.disabled}
              />
              <label
                className={[
                  styles.label,
                  props.labelClassName,
                  "label",
                  item.disabled ? "disabled" : "",
                  selected ? "selected" : "",
                ].join(" ")}
                htmlFor={props.name + "-" + index}
              >
                {item.label}
              </label>
            </div>
          );
        })}
    </div>
  );
};

RadioButtons.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.any.isRequired, value: PropTypes.any.isRequired, disabled: PropTypes.bool }),
  ),
  onChange: PropTypes.func,
  value: PropTypes.any,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  topLabelClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  itemWrapperClassName: PropTypes.string,
};

export default RadioButtons;
